let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5Vt5L")).then(() => parcelRequire('6cT2s'));